import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MapComponent } from './map.component';

const routes: Routes = [
  {path: '', component: MapComponent},
  {path: ':id', component: MapComponent},
  {path: 'index', component: MapComponent},
  {path: 'index/:id', component: MapComponent},
  {path: 'class', component: MapComponent},
  {path: 'class/:sched', component: MapComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
